import AppLayout from "../layout/AppLayout";
import Iframe from "react-iframe";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";

const SolverIframe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const url = location.state?.url || "https://for-freight.dataports.com.es";

  return (
    <AppLayout>
      <div style={{ padding: "16px" }}>
        <div style={{ display: "flex", justifyContent: "right", marginBottom: "16px" }}>
          <Button type="primary" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        </div>
        <div style={{ width: "100%", height: "150vh" }}>
          <Iframe
            url={url}
            width="100%"
            height="100%"
            id="secured-iframe"
            display="block"
            position="relative"
          />
        </div>
      </div>
    </AppLayout>
  );
};

export default SolverIframe;
